import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import moment from 'moment';
import Fa from 'react-fontawesome';
import { each } from 'lodash';
import ProgressBar from '../../../../components/progress-bar';
import DatetimeDisplay from '../../../../components/date-time-display';
import NumberDisplay from '../../../../components/number-display';
import MoneyDisplay from '../../../../components/money-display';

import {
  getAccounts,
  getAccountLoading,
  getAccountLoaded,
  getTrackingsLoading,
  getTrackingsLoaded,
  getUnlinkedContacts,
  getUnlinkedContactLoading,
  getUnlinkedContactLoaded,
} from '../../CEReducer';

import styles from '../winloss-stats/styles.css';

class CEStats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      unsubmitted: {},
      submitted: {},
      noFeedback: {},
      minDate: null,
      linkedInterviews: {},
    };
  }

  componentDidMount() {
    this.calculate();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.loaded && !prevProps.loaded) || (this.props.submitStatus !== prevProps.submitStatus && this.props.submitStatus === 'success')) {
      this.calculate();
    }
  }

  calculate() {
    const { accounts } = this.props;

    const unsubmitted = {
      count: 0,
      amount: 0,
      accountIds: [],
    };

    const noFeedback = {
      count: 0,
      amount: 0,
      accountIds: [],
    };

    const submitted = {
      count: 0,
      amount: 0,
      accountIds: [],
    };
    let minDate = null;
    const linkedInterviews = {
      count: 0,
      amount: 0,
      accountIds: [],
    };
    each(accounts, (account) => {
      const { tracking, amount } = account;
      const submmitted = (tracking && tracking.submittedContactIds && tracking.submittedContactIds.length > 0);
      if (!minDate) {
        minDate = account.minCloseDate;
      } else if (account.minCloseDate) {
        minDate = moment.min(account.minCloseDate, minDate);
      }
      if (submmitted) {
        submitted.count += 1;
        submitted.amount += amount;
        submitted.accountIds.push(account.account_id);

        const approvedContacts = [];
        each(tracking.trackings, (trk) => {
          each(trk.contacts, (contact) => {
            if (contact.approved) {
              linkedInterviews.count += 1;
              approvedContacts.push(contact);
            }
          });
        });

        if (approvedContacts.length > 0) {
          linkedInterviews.amount += amount;
          linkedInterviews.accountIds.push(account.account_id);
        } else {
          noFeedback.count += 1;
          noFeedback.amount += amount;
          noFeedback.accountIds.push(account.account_id);
        }
      } else {
        unsubmitted.count += 1;
        unsubmitted.amount += amount;
        unsubmitted.accountIds.push(account.account_id);
      }
    });
    this.setState({
      unsubmitted, submitted, noFeedback, minDate, linkedInterviews,
    });
  }

  renderStats(title, stats, countTooltip, amountTooltip) {
    const { minDate } = this.state;
    const dateComp = minDate ? <span>Since <DatetimeDisplay value={minDate} format="long" /></span> : null;
    return (
      <div className={`panel panel-default ${styles.panel}`}>
        <div className="panel-heading">
          {title} {dateComp}
        </div>
        <div className="panel-body">
          <table className="table table-condensed">
            <tbody>
              <tr>
                <td className="text-center">
                  Accounts <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={countTooltip}><Fa className="text-active" name="info-circle" /></OverlayTrigger>
                </td>
                <td className="text-center">
                  TTV <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={amountTooltip}><Fa className="text-active" name="info-circle" /></OverlayTrigger>
                </td>
              </tr>
              <tr>
                <td className="text-center"><strong><NumberDisplay value={stats.count} precision={0} /></strong></td>
                <td className="text-center"><strong><MoneyDisplay value={stats.amount} abbreviated /></strong></td>
              </tr>
              <tr><td>&nbsp;</td><td>&nbsp;</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    const {
      loaded,
      unlinkedLoading,
      totalUnlinked,
    } = this.props;
    const {
      submitted, linkedInterviews,
      noFeedback, minDate,
    } = this.state;
    if (!loaded) {
      return (
        <div>
          <ProgressBar />
          <p />
        </div>
      );
    }
    const since = minDate ? <span>since <DatetimeDisplay value={minDate} format="long" /></span> : null;

    const noFeedbackCountTip = (
      <Tooltip id="no-feedback-count">
        <div>Count of accounts that have not provided feedback {since}.</div>
      </Tooltip>
    );
    const noFeedbackAmountTip = (
      <Tooltip id="no-feedback-count">
        <div>The total value accounts {since} that have not provided feedback, calculated by summing all won opportunities for an account {since}.</div>
      </Tooltip>
    );
    const submittedCountTip = (
      <Tooltip id="no-feedback-count">
        <div>Count of accounts that have had at least one contact submitted to TruVoice {since}.</div>
      </Tooltip>
    );
    const submittedAmountTip = (
      <Tooltip id="no-feedback-count">
        <div>The total value of an account {since}, calculated by summing all won opportunities for an account {since}.</div>
      </Tooltip>
    );

    const total = linkedInterviews.count + totalUnlinked;
    return (
      <div className="row">
        <div className="col-sm-4">
          {this.renderStats('No Feedback', noFeedback, noFeedbackCountTip, noFeedbackAmountTip)}
        </div>
        <div className="col-sm-4">
          {this.renderStats('Submitted', submitted, submittedCountTip, submittedAmountTip)}
        </div>
        <div className="col-sm-4">
          <div className={`panel panel-default ${styles.panel}`}>
            <div className="panel-heading">
              Captured Feedback
            </div>
            <div className="panel-body">
              <table className="table table-condensed">
                <tbody>
                  <tr>
                    <td>Linked interviews</td>
                    <td className="text-right"><NumberDisplay value={linkedInterviews.count} precision={0} /></td>
                  </tr>
                  <tr>
                    <td>Unlinked interviews</td>
                    <td className="text-right">
                      {unlinkedLoading && (<Fa name="spinner" spin />)}
                      {!unlinkedLoading && (<NumberDisplay value={totalUnlinked} precision={0} />)}
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Total interviews</strong></td>
                    <td className="text-right">
                      <strong>
                        {unlinkedLoading && (<Fa name="spinner" spin />)}
                        {!unlinkedLoading && (<NumberDisplay value={total} precision={0} />)}
                      </strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    accounts: getAccounts(state),
    loaded: !getTrackingsLoading(state) && getTrackingsLoaded(state) &&
      !getAccountLoading(state) && getAccountLoaded(state),
    unlinkedLoading: getUnlinkedContactLoading(state) || !getUnlinkedContactLoaded(state),
    totalUnlinked: getUnlinkedContacts(state).length,
  };
}
CEStats.propTypes = {
  accounts: PropTypes.arrayOf(PropTypes.shape({})),
  loaded: PropTypes.bool,
  submitStatus: PropTypes.string,
  unlinkedLoading: PropTypes.bool,
  totalUnlinked: PropTypes.number,
};
CEStats.defaultProps = {
  accounts: [],
  loaded: false,
  submitStatus: null,
  unlinkedLoading: true,
  totalUnlinked: 0,
};

export default connect(mapStateToProps)(CEStats);
